import TrisGame from "../components/tris/TrisGame";


export default function NotFound() {
  return (
    <div className="text-white flex flex-col items-center justify-center min-h-screen w-full mx-auto gap-12">
      <div className="flex flex-col gap-3">
        <h2 className="lg:text-7xl text-5xl font-bold tracking-wider">404</h2>
        <p className="lg:text-3xl text-2xl italic">Pagina non trovata</p>
      </div>

      <TrisGame/>
    </div>
  );
}